const middleware = {}

middleware['cacheControl'] = require('../middleware/cacheControl.js')
middleware['cacheControl'] = middleware['cacheControl'].default || middleware['cacheControl']

middleware['frontendRedirect'] = require('../middleware/frontendRedirect.js')
middleware['frontendRedirect'] = middleware['frontendRedirect'].default || middleware['frontendRedirect']

export default middleware
